/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DriverBreakDriverDto } from '../models/DriverBreakDriverDto';
import type { DriverBreakListedAdminDto } from '../models/DriverBreakListedAdminDto';
import type { DriverBreakSourceType } from '../models/DriverBreakSourceType';
import type { DriverBreakStatus } from '../models/DriverBreakStatus';
import type { GetDriverBreaksDriverResponse } from '../models/GetDriverBreaksDriverResponse';
import type { Pagination1OfDriverBreakListedAdminDto } from '../models/Pagination1OfDriverBreakListedAdminDto';
import type { PostApproveDriverBreakAdminRequest } from '../models/PostApproveDriverBreakAdminRequest';
import type { PostDriverBreakAdminRequest } from '../models/PostDriverBreakAdminRequest';
import type { PostDriverBreakRequestDriver } from '../models/PostDriverBreakRequestDriver';
import type { PostRejectDriverBreakAdminRequest } from '../models/PostRejectDriverBreakAdminRequest';
import type { PutDriverBreakAttachmentImageRequestDriver } from '../models/PutDriverBreakAttachmentImageRequestDriver';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DriverBreaksService {
    /**
     * @returns DriverBreakDriverDto OK
     * @throws ApiError
     */
    public static postDriverBreakDriver({
        requestBody,
    }: {
        requestBody?: PostDriverBreakRequestDriver,
    }): CancelablePromise<DriverBreakDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/driverbreaks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetDriverBreaksDriverResponse OK
     * @throws ApiError
     */
    public static getDriverBreaksDriver({
        createdAtFrom,
        createdAtTo,
        startAtFrom,
        startAtTo,
        endAtFrom,
        endAtTo,
        statuses,
        page,
        limit,
    }: {
        createdAtFrom?: string,
        createdAtTo?: string,
        startAtFrom?: string,
        startAtTo?: string,
        endAtFrom?: string,
        endAtTo?: string,
        statuses?: Array<DriverBreakStatus>,
        page?: number,
        limit?: number,
    }): CancelablePromise<GetDriverBreaksDriverResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverbreaks',
            query: {
                'createdAtFrom': createdAtFrom,
                'createdAtTo': createdAtTo,
                'startAtFrom': startAtFrom,
                'startAtTo': startAtTo,
                'endAtFrom': endAtFrom,
                'endAtTo': endAtTo,
                'statuses': statuses,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns DriverBreakDriverDto OK
     * @throws ApiError
     */
    public static getCurrentActiveDriverBreakDriver(): CancelablePromise<DriverBreakDriverDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/driver/v1/driverbreaks/current/active',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postCancelDriverBreakDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/driverbreaks/{id}/cancel',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns DriverBreakDriverDto OK
     * @throws ApiError
     */
    public static postCompleteDriverBreakDriver({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverBreakDriverDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/driver/v1/driverbreaks/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns DriverBreakDriverDto OK
     * @throws ApiError
     */
    public static putDriverBreakAttachmentImageDriver({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PutDriverBreakAttachmentImageRequestDriver,
    }): CancelablePromise<DriverBreakDriverDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/driver/v1/driverbreaks/{id}/attachment-image',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverBreaks`
     * @returns Pagination1OfDriverBreakListedAdminDto OK
     * @throws ApiError
     */
    public static getDriverBreaksAdmin({
        driverId,
        regionId,
        status,
        source,
        linkedDriverShiftId,
        startAtFrom,
        startAtTo,
        endAtFrom,
        endAtTo,
        requestedByUserId,
        approvedByUserId,
        page,
        limit,
    }: {
        driverId?: number,
        regionId?: number,
        status?: DriverBreakStatus,
        source?: DriverBreakSourceType,
        linkedDriverShiftId?: string,
        startAtFrom?: string,
        startAtTo?: string,
        endAtFrom?: string,
        endAtTo?: string,
        requestedByUserId?: string,
        approvedByUserId?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfDriverBreakListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverbreaks',
            query: {
                'driverId': driverId,
                'regionId': regionId,
                'status': status,
                'source': source,
                'linkedDriverShiftId': linkedDriverShiftId,
                'startAtFrom': startAtFrom,
                'startAtTo': startAtTo,
                'endAtFrom': endAtFrom,
                'endAtTo': endAtTo,
                'requestedByUserId': requestedByUserId,
                'approvedByUserId': approvedByUserId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverBreaks`
     * @returns DriverBreakListedAdminDto OK
     * @throws ApiError
     */
    public static postDriverBreakAdmin({
        requestBody,
    }: {
        requestBody?: PostDriverBreakAdminRequest,
    }): CancelablePromise<DriverBreakListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverbreaks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewDriverBreaks`
     * @returns DriverBreakListedAdminDto OK
     * @throws ApiError
     */
    public static getDriverBreakAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverBreakListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/driverbreaks/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverBreaks`
     * @returns DriverBreakListedAdminDto OK
     * @throws ApiError
     */
    public static postApproveDriverBreakAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostApproveDriverBreakAdminRequest,
    }): CancelablePromise<DriverBreakListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverbreaks/{id}/approve',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverBreaks`
     * @returns DriverBreakListedAdminDto OK
     * @throws ApiError
     */
    public static postRejectDriverBreakAdmin({
        id,
        requestBody,
    }: {
        id: string,
        requestBody?: PostRejectDriverBreakAdminRequest,
    }): CancelablePromise<DriverBreakListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverbreaks/{id}/reject',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverBreaks`
     * @returns DriverBreakListedAdminDto OK
     * @throws ApiError
     */
    public static postCancelDriverBreakAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverBreakListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverbreaks/{id}/cancel',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageDriverBreaks`
     * @returns DriverBreakListedAdminDto OK
     * @throws ApiError
     */
    public static postCompleteDriverBreakAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<DriverBreakListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/driverbreaks/{id}/complete',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
